import { combineReducers } from '@reduxjs/toolkit';
import loading, { loadingInitialState } from './slicers/loading.slice';
import apiMessage, { apiMessageInitialState } from './slicers/api-message.slice';
import auth, { authInitialState } from './slicers/auth.slice';
import sidebar, { sidebarInitialState } from './slicers/sidebar.slice';
import breadcrumb, { breadcrumbInitialState } from './slicers/breadcrumb.slice';
import manageRole, { manageRoleInitialState } from './slicers/manage-role.slice';
import dashboardOverview, {
  dashboardOverviewInitialState,
} from './slicers/dashboard-overview.slice';
import dashboardWorkQueues, {
  dashboardWorkQueuesInitialState,
} from './slicers/dashboard-work-queues.slice';
import dashboardSla, { dashboardSlaInitialState } from './slicers/dashboard-sla.slice';
import dashboardRevenue, { dashboardRevenueInitialState } from './slicers/dashboard-revenue.slice';
import dashboardFunnel, { dashboardFunnelInitialState } from './slicers/dashboard-funnel.slice';
import dashboardTopServices, {
  dashboardTopServicesInitialState,
} from './slicers/dashboard-top-services.slice';
import dashboardStaffWorkload, {
  dashboardStaffWorkloadInitialState,
} from './slicers/dashboard-staff-workload.slice';
import dashboardRecentActivities, {
  dashboardRecentActivitiesInitialState,
} from './slicers/dashboard-recent-activities.slice';
import adminCustomers, { adminCustomersInitialState } from './slicers/admin-customers.slice';
import adminCustomerDetail, {
  adminCustomerDetailInitialState,
} from './slicers/admin-customer-detail.slice';
import adminCustomerCompanies, {
  adminCustomerCompaniesInitialState,
} from './slicers/admin-customer-companies.slice';
import adminCustomerOrders, {
  adminCustomerOrdersInitialState,
} from './slicers/admin-customer-orders.slice';
import adminCustomerInvoices, {
  adminCustomerInvoicesInitialState,
} from './slicers/admin-customer-invoices.slice';
import adminCompanies, { adminCompaniesInitialState } from './slicers/admin-companies.slice';
import adminCompanyDetail, {
  adminCompanyDetailInitialState,
} from './slicers/admin-company-detail.slice';
import adminServiceCategories, {
  adminServiceCategoriesInitialState,
} from './slicers/admin-service-categories.slice';
import adminServices, { adminServicesInitialState } from './slicers/admin-services.slice';
import adminServiceOptions, {
  adminServiceOptionsInitialState,
} from './slicers/admin-service-options.slice';
import adminAddonOptions, {
  adminAddonOptionsInitialState,
} from './slicers/admin-addon-options.slice';
import adminPackages, { adminPackagesInitialState } from './slicers/admin-packages.slice';
import adminAddons, { adminAddonsInitialState } from './slicers/admin-addons.slice';
import adminFormDefinitionVersions, {
  adminFormDefinitionVersionsInitialState,
} from './slicers/admin-form-definition-versions.slice';
import adminFormDefinitionVersionDetail, {
  adminFormDefinitionVersionDetailInitialState,
} from './slicers/admin-form-definition-version-detail.slice';
import adminFormDefinitionVersionPreview, {
  adminFormDefinitionVersionPreviewInitialState,
} from './slicers/admin-form-definition-version-preview.slice';
import adminAuditLogs, { adminAuditLogsInitialState } from './slicers/admin-audit-logs.slice';
import orders, { ordersInitialState } from './slicers/orders.slice';
import catalog, { catalogInitialState } from './slicers/catalog.slice';
import comments, { commentsInitialState } from './slicers/comment.slice';
import notification, { notificationInitialState } from './slicers/notification.slice';
import notificationDropdown, {
  notificationDropdownInitialState,
} from './slicers/notification-dropdown.slice';
import billing, { billingInitialState } from './slicers/billing.slice';
import coupon, { couponInitialState } from './slicers/coupon.slice';
import customer, { customerInitialState } from './slicers/customer.slice';
import payment, { paymentInitialState } from '@/redux/slicers/payment-settings.slice';

const rootState = {
  loading,
  apiMessage,
  auth,
  sidebar,
  breadcrumb,
  manageRole,
  dashboardOverview,
  dashboardWorkQueues,
  dashboardSla,
  dashboardRevenue,
  dashboardFunnel,
  dashboardTopServices,
  dashboardStaffWorkload,
  dashboardRecentActivities,
  adminCustomers,
  adminCustomerDetail,
  adminCustomerCompanies,
  adminCustomerOrders,
  adminCustomerInvoices,
  adminCompanies,
  adminCompanyDetail,
  adminServiceCategories,
  adminServices,
  adminServiceOptions,
  adminAddonOptions,
  adminPackages,
  adminAddons,
  adminFormDefinitionVersions,
  adminFormDefinitionVersionDetail,
  adminFormDefinitionVersionPreview,
  adminAuditLogs,
  orders,
  catalog,
  comments,
  notification,
  notificationDropdown,
  billing,
  coupon,
  customer,
  payment,
};

export type RawRootState = typeof rootState;
export const allInitialStates = {
  loadingInitialState,
  apiMessageInitialState,
  authInitialState,
  sidebarInitialState,
  breadcrumbInitialState,
  manageRoleInitialState,
  dashboardOverviewInitialState,
  dashboardWorkQueuesInitialState,
  dashboardSlaInitialState,
  dashboardRevenueInitialState,
  dashboardFunnelInitialState,
  dashboardTopServicesInitialState,
  dashboardStaffWorkloadInitialState,
  dashboardRecentActivitiesInitialState,
  adminCustomersInitialState,
  adminCustomerDetailInitialState,
  adminCustomerCompaniesInitialState,
  adminCustomerOrdersInitialState,
  adminCustomerInvoicesInitialState,
  adminCompaniesInitialState,
  adminCompanyDetailInitialState,
  adminServiceCategoriesInitialState,
  adminServicesInitialState,
  adminServiceOptionsInitialState,
  adminAddonOptionsInitialState,
  adminPackagesInitialState,
  adminAddonsInitialState,
  adminFormDefinitionVersionsInitialState,
  adminFormDefinitionVersionDetailInitialState,
  adminFormDefinitionVersionPreviewInitialState,
  adminAuditLogsInitialState,
  ordersInitialState,
  catalogInitialState,
  commentsInitialState,
  notificationInitialState,
  notificationDropdownInitialState,
  billingInitialState,
  couponInitialState,
  customerInitialState,
  paymentInitialState,
};

const rootReducer = combineReducers(rootState);
export const rootReducers = rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
